import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  dataForMonth: [],
  addData: {},
  addDataHomeDashboardDataItem: {},
  addHomeDashboardDataData: {},
  drawerOpeningStatus: {},
  cashDrawerData: {},
  HomeDashboardDataDrawerData: {},
  HomeDashboardData: [],
  kitchenPanelAverageTime: [],
  allData: [],
  sorted: [],
  saleTypes: [],
  viewHomeDashboardDataStatus: false,
  viewHomeDashboardDataCloseStatus: false,
};

const slice = createSlice({
  name: 'Home',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },
    updateHomeDashboardDataStatus(state, value) {
      state.viewHomeDashboardDataStatus = value.payload;
    },
    updateHomeDashboardDataCloseStatus(state, value) {
      state.viewHomeDashboardDataCloseStatus = value.payload;
    },
    getAllSaleTypesSuccess(state, action) {
      state.saleTypes = action.payload.data;
    },
    getDrawerOpeningStatus(state, action) {
      state.drawerOpeningStatus = action.payload.data;
    },
    getHomeDashboardDataDrawerData(state, action) {
      state.HomeDashboardDataDrawerData = action.payload.data;
    },
    getIngredientPurchasePatternSuccess(state, action) {
      state.data = action.payload.data;
      state.otherData = action.payload.otherData;
    },
    getHomeDashboardDataForMonthSuccess(state, action) {
      state.dataForMonth = action.payload.data;
    },
    getCashDrawerDataSuccess(state, action) {
      state.cashDrawerData = action.payload.data;
    },
    getKitchenPanelAverageTimeDataSuccess(state, action) {
      state.kitchenPanelAverageTime = action.payload.data;
    },
    getHomeDashboardDataGlobalSuccess(state, action) {
      state.globalData = action.payload.data;
    },
    getAllHomeDashboardDataData(state, action) {
      state.allData = action.payload.data;
    },
    addOrUpdateHomeDashboardData(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },
    addOrUpdateHomeDashboardDataItemStatus(state, action) {
      state.addDataHomeDashboardDataItem = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },
    clearAddOrUpdateHomeDashboardData(state) {
      state.addData = { data: null, time: moment.now().toString() };
    },
    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },
    onNextStep(state) {
      state.checkout.activeStep += 1;
    },
    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

export default slice.reducer;

export function getKitchenPanelAverageTimeData(data) {
  return async () => {
    try {
      const response = await get(`getKitchenPanelAverageTimeData`, data);
      if (response.status) {
        dispatch(slice.actions.getKitchenPanelAverageTimeDataSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCashDrawerData(data) {
  return async () => {
    try {
      const response = await get(`getCashDrawerData`, data);
      if (response.status) {
        dispatch(slice.actions.getCashDrawerDataSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getHomeDashboardDataForMonth(data) {
  return async () => {
    try {
      const response = await get(`getPOSDataBetweenDateRange`, data);
      if (response.status) {
        dispatch(slice.actions.getHomeDashboardDataForMonthSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getHomeDashboardData(data) {
  return async () => {
    try {
      const response = await get(`getPOSDataBetweenDateRange`, data);
      if (response.status) {
        dispatch(slice.actions.getIngredientPurchasePatternSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getHomeDashboardGlobalDataForDateRange(data) {
  return async () => {
    try {
      const response = await get(`getPOSDataBetweenDateRange`, data);
      if (response.status) {
        dispatch(slice.actions.getHomeDashboardDataGlobalSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function searchHomeDashboardDatas(name, phone) {
  return async () => {
    try {
      const response = await get(`HomeDashboardData_search?name=${name}&phone=${phone}`);
      if (response.status) {
        dispatch(slice.actions.getIngredientPurchasePatternSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addHomeDashboardData(body) {
  return async () => {
    try {
      const response = await post(`addHomeDashboardData`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateHomeDashboardData(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addLoyaltyRecord(body) {
  return async () => {
    try {
      const response = await post(`addLoyaltyRecord`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateHomeDashboardData(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateHomeDashboardData(body) {
  return async () => {
    try {
      const response = await put(`updateHomeDashboardData`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateHomeDashboardData(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
